// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13kWV","right":"Footer_right__3gjht","buttons":"Footer_buttons__2daed"};